import type { ReactNode } from 'react';
import { Button } from '@mui/material';
import ExtensionOffRounded from '@mui/icons-material/ExtensionOffRounded';
import LockRounded from '@mui/icons-material/LockRounded';
import { Link as RouterLink } from 'react-router';
import { EmptyState } from '@/components/EmptyState';
import { useSession } from './session';
import type { Role } from './types';

/** Renders children only for the given roles. */
export function RequireRole({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { role } = useSession();
  if (!roles.includes(role)) {
    return (
      <EmptyState
        icon={LockRounded}
        title="Acesso restrito"
        description="Esta área não está disponível para o seu perfil."
        action={
          <Button component={RouterLink} to="/" variant="contained">
            Voltar ao início
          </Button>
        }
      />
    );
  }
  return children;
}

/** Renders children only while the module is switched on. */
export function RequireModule({ module, children }: { module: string; children: ReactNode }) {
  const { hasModule, isAdmin } = useSession();
  if (!hasModule(module)) {
    return (
      <EmptyState
        icon={ExtensionOffRounded}
        title="Módulo desativado"
        description={
          isAdmin
            ? 'Este módulo está desligado. Ative-o na Administração para voltar a usá-lo.'
            : 'Este conteúdo não está disponível no momento.'
        }
        action={
          <Button component={RouterLink} to={isAdmin ? '/admin' : '/'} variant="contained">
            {isAdmin ? 'Ir para a Administração' : 'Voltar ao início'}
          </Button>
        }
      />
    );
  }
  return children;
}
